import { createContext, useContext, useEffect, useState } from "react";
import { apiClient } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await apiClient.get("/auth/me");
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password, human = {}) => {
    const { data } = await apiClient.post("/auth/login", { email, password, ...human });
    if (data.token) localStorage.setItem("pf_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await apiClient.post("/auth/logout"); } catch {}
    localStorage.removeItem("pf_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
